<template>
    <div class="mag-submenu-groups">
        <mag-submenu-item-group
            v-for="item in magGroups"
            :key="item.id"
            :item="item"
            :groupItems="itemsByGroupId[item.id]"
        />
    </div>
</template>

<script>
import MagSubmenuItemGroup from "./MagSubmenuItemGroup.vue";
import { groupBy } from "lodash";

export default {
    props: ["active", "item"],
    components: { MagSubmenuItemGroup },
    data() {
        return {
            magGroups: [
                // {
                //     id: "figures",
                //     label: "Données chiffrées",
                // },

                {
                    id: "collective-agreements",
                    label: "Conventions et accords collectifs",
                },
                // {
                //     id: "employment-path-training",
                //     label: "Emploi - Parcours et formation professionnels",
                // },
                {
                    id: "social-protection",
                    label: "Protection sociale",
                },
                {
                    id: "life-employment-contract",
                    label: "Vie du contrat de travail",
                },
                // {
                //     id: "savings-schemes",
                //     label: "Dispositifs d’épargne salariale",
                // },
                {
                    id: "others",
                    label: "Divers",
                },
            ],
        };
    },
    computed: {
        itemsByGroupId() {
            if (!this.item.children) return {};
            return groupBy(this.item.children, child => child.group || "others");
        },
    },
};
</script>

<style lang="sass" scoped>

.mag-sub-menu-items-transition
    &-enter-active, &-leave, &-leave-to
        transition: transform .15s ease-in, opacity .15s ease-in

    &-enter, &-leave-to
        opacity: 0
        transform: translate(0, -5px)

.mag-submenu-groups
    display: flex
    flex-direction: column
</style>
